var _path, _rect, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 85H23C22.4477 85 22 84.5523 22 84V12C22 11.4477 22.4477 11 23 11H57V26C57 27.1046 57.8954 28 59 28H74V84C74 84.5523 73.5523 85 73 85ZM77 28V84C77 86.2091 75.2091 88 73 88H23C20.7909 88 19 86.2091 19 84V12C19 9.79086 20.7909 8 23 8H57H58.3431C59.404 8 60.4214 8.42143 61.1716 9.17157L68.5 16.5L75.8284 23.8284C76.5786 24.5786 77 25.596 77 26.6569V28Z",
    fill: "#055AAE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37,
    width: 72,
    height: 32,
    rx: 4,
    fill: "#055AAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1328 40.9492H31.4582L36.8559 57.7848H36.9477L42.4004 40.9492H49.7625V65H44.1629V59.0332L44.6953 48.0543L44.6035 48.0359L38.802 65H35.0383L29.2918 48.1828L29.2 48.2012L29.7324 59.0332V65H24.1328V40.9492Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.843 45.2453H59.1441V60.7039H61.843C63.324 60.7039 64.4867 60.2021 65.3312 59.1984C66.1758 58.1826 66.598 56.8301 66.598 55.141V50.7715C66.598 49.0824 66.1758 47.7422 65.3312 46.7508C64.4867 45.7471 63.324 45.2453 61.843 45.2453ZM62.2285 65H53.5445V40.9492H62.2285C65.0926 40.9492 67.4671 41.8733 69.352 43.7215C71.2491 45.5697 72.1977 47.9319 72.1977 50.8082V55.141C72.1977 58.0173 71.2491 60.3796 69.352 62.2277C67.4671 64.0759 65.0926 65 62.2285 65Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/MD.7ba52145ba124e10acda70c872f61349.svg";
export { ForwardRef as ReactComponent };